module.exports = __webpack_public_path__ + "static/no-webcam-filler--white-7a0872f64533d481da949437a4cf962d.svg";